import React from 'react';
import { useParams } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import StoreNav from '../components/store/StoreNav';
import { useProductCategories } from '../hooks/useProductCategories';
import { isCategoryUrlSlug } from '../lib/templateStoreCategories';
import TemplateDetailPage from './TemplateDetailPage';
import TemplatesListingPage from './TemplatesListingPage';

export default function TemplateSlugRoute() {
  const { slug } = useParams();
  const { categories, loading } = useProductCategories();

  if (loading) {
    return (
      <div className="min-h-screen bg-muted/20">
        <StoreNav />
        <div className="flex min-h-[40vh] items-center justify-center">
          <Loader2 className="h-8 w-8 animate-spin text-primary" aria-label="Loading" />
        </div>
      </div>
    );
  }

  if (isCategoryUrlSlug(slug, categories)) {
    return <TemplatesListingPage categorySlug={slug} categories={categories} />;
  }

  return <TemplateDetailPage />;
}
